var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSied(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 210.277 528.855",
    style: {
      enableBackground: "new 0 0 210.277 528.855"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SIED",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_4_",
    x: -160.121,
    y: 218.456,
    style: {
      display: "inline",
      fill: "none"
    },
    width: 536.667,
    height: 283.54
  }), /*#__PURE__*/React.createElement("text", {
    id: "XMLID_6_",
    transform: "matrix(1 0 0 1 108.2131 364.1461)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      fontFamily: "'BaskOldFace'",
      fontSize: 213,
      letterSpacing: 2
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 223.224,
    y: 0,
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      fontFamily: "'BaskOldFace'",
      fontSize: 175,
      letterSpacing: 2
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: -214.814,
    y: 61,
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeMiterlimit: 10,
      fontFamily: "'BaskOldFace'",
      fontSize: 175,
      letterSpacing: 2
    }
  }, "E    D")), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_16_",
    x: -104.104,
    y: 114.388,
    style: {
      display: "inline",
      fill: "none"
    },
    width: 536.667,
    height: 171.099
  }), /*#__PURE__*/React.createElement("text", {
    id: "XMLID_7_",
    transform: "matrix(1 0 0 1 -104.104 260.078)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      fontFamily: "'BaskOldFace'",
      fontSize: 213,
      letterSpacing: 2
    }
  }, "S   "), /*#__PURE__*/React.createElement("tspan", {
    x: 280.113,
    y: 0,
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      fontFamily: "'BaskOldFace'",
      fontSize: 213,
      letterSpacing: -14
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 318.454,
    y: 0,
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      fontFamily: "'BaskOldFace'",
      fontSize: 213,
      letterSpacing: 2
    }
  }, "I  "), /*#__PURE__*/React.createElement("tspan", {
    x: 509.272,
    y: 0,
    style: {
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      fontFamily: "'BaskOldFace'",
      fontSize: 175,
      letterSpacing: 2
    }
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_11_",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#A5A4A4",
      strokeMiterlimit: 10
    },
    x1: -128.588,
    y1: 286.488,
    x2: 333.634,
    y2: 286.488
  })), /*#__PURE__*/React.createElement("g", {
    id: "All_The_World_Inside",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2_",
    x: -118.119,
    y: 556.075,
    style: {
      display: "inline",
      fill: "none"
    },
    width: 462.222,
    height: 146.283
  }), /*#__PURE__*/React.createElement("text", {
    id: "XMLID_1_",
    transform: "matrix(1 0 0 1 91.9496 584.0424)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#211F1F",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10,
      fontFamily: "'CenturyGothic'",
      fontSize: 38
    }
  }, "all"), /*#__PURE__*/React.createElement("tspan", {
    x: -34.551,
    y: 47,
    style: {
      fill: "#211F1F",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10,
      fontFamily: "'CenturyGothic'",
      fontSize: 37
    }
  }, "worlds "), /*#__PURE__*/React.createElement("tspan", {
    x: -44.654,
    y: 94,
    style: {
      fill: "#211F1F",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10,
      fontFamily: "'CenturyGothic'",
      fontSize: 42,
      letterSpacing: 3
    }
  }, "inside")), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#050606",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M-104.447,638.83 c6.344-9.532,79.393-115.218,214-117.772c140.864-2.673,218.869,110.069,224,117.772"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Seed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    style: {
      fill: "#F9F9FA"
    },
    d: "M91.568,75.097c16.145-17.658,12.216-95.963,33.333-31.333s22.04,16.131,29.333,30 c27.957,53.167,53.743,102.206,43.333,167.333c-5.622,35.17-16.309,40.688-35.679,88.667c-20.933,51.852-43.46,133.333-36.887,160 c6.572,26.667-16.777-7.446-22.767-20.667c-4.417-9.749-6.732-24.611,0-34c2.166-3.021,4.68-4.667,7.333-10 c2.381-4.786,3.22-9.217,4-13.333c0.601-3.171,1.384-7.306,1.333-12.667c-0.064-6.835-1.444-12.147-4-20 c-2.714-8.337-6.288-19.32-10.325-27.703c-11.87-24.651-42.074-56.598-47-62c-41.1-45.072-49.16-135.736-15.341-173.63 C55.781,96.103,70.471,98.171,91.568,75.097z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    style: {
      fill: "#5E5A5C"
    },
    d: "M92.05,75.494c7.493-8.51,9.359-21.939,11.678-32.63 c1.285-5.923,2.339-11.999,4.309-17.744c1.001-2.92,2.764-7.943,6.181-4.527c5.169,5.168,7.408,15.144,9.621,21.778 c3.224,9.665,6.3,19.649,11.221,28.625c2.34,4.267,6.707,11.011,11.643,5.945c1.202-1.234,2.468-4.394,4.148-4.969 c1.119-0.383,1.237-0.017,2.085,0.744c1.432,1.284,2.222,4.015,3.096,5.679c1.552,2.957,3.103,5.915,4.643,8.878 c11.186,21.523,21.987,43.413,29.307,66.6c13.115,41.541,13.485,87.874-6.106,127.394c-9.315,18.79-18.504,37.44-26.016,57.057 c-8.024,20.952-14.973,42.34-20.937,63.968c-5.358,19.43-10.173,39.207-12.573,59.248c-0.83,6.933-1.412,13.985-0.964,20.969 c0.186,2.906,0.699,5.663,1.317,8.502c0.418,1.924,2.35,8.439-0.951,7.768c-2.181-0.443-4.467-4.082-5.787-5.708 c-2.516-3.099-4.8-6.394-6.978-9.737c-4.462-6.846-8.808-14.04-10.882-22.015c-1.441-5.542-2.052-11.492-0.954-17.153 c1.301-6.713,5.617-10.236,9.155-15.606c5.342-8.108,7.277-19.765,7.191-29.335c-0.1-11.182-4.467-22.109-8.14-32.52 c-3.534-10.016-7.842-19.448-13.573-28.395c-10.358-16.169-22.977-30.909-35.911-45.057 C32.181,265.149,19.17,228.56,17.828,190.648c-0.668-18.857,1.559-38.462,9.2-55.867c3.525-8.029,8.295-15.33,14.465-21.574 c7.366-7.455,16.209-12.36,25.178-17.562C76.177,90.133,84.56,83.55,92.05,75.494c0.492-0.529-0.472-1.325-0.965-0.795 c-8.672,9.328-18.525,16.186-29.51,22.434c-9.131,5.194-17.588,10.97-24.494,18.998c-11.086,12.886-16.557,29.842-18.994,46.419 c-5.71,38.837,3.192,82.448,25.44,114.988c9.356,13.685,21.817,25.235,32.239,38.104c6.929,8.556,13.6,17.398,19.294,26.832 c6.67,11.051,10.855,23.159,14.832,35.378c1.936,5.948,3.831,11.932,4.295,18.205c0.491,6.642-0.568,13.344-2.069,19.802 c-1.535,6.603-4.538,11.82-8.873,16.974c-3.044,3.619-4.851,7.806-5.517,12.484c-2.443,17.173,8.097,33.924,18.161,46.925 c1.543,1.994,5.904,8.775,9.197,8c3.819-0.9,0.598-9.863,0.218-11.801c-3.184-16.227,0.946-34.492,4.189-50.383 c9.537-46.733,24.748-93.651,45.618-136.571c7.295-15.002,15.788-29.478,20.05-45.732c6.02-22.957,6.857-47.523,3.3-70.941 c-3.708-24.411-12.371-47.686-22.785-69.968c-5.579-11.938-11.647-23.639-17.767-35.306c-0.933-1.778-3.205-9.221-6.653-8.991 c-4.128,0.274-4.609,8.78-9.574,6.899c-5.263-1.993-8.259-12.194-10.07-16.671c-4.296-10.621-7.147-21.786-11.708-32.299 c-2.349-5.414-7.927-15.889-12.208-5.974c-4.907,11.364-5.618,24.582-9.143,36.411c-1.645,5.52-3.598,11.393-7.465,15.784 C90.607,75.243,91.571,76.039,92.05,75.494z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSied);
export default __webpack_public_path__ + "static/media/Sied.19b2964b88ba6644ad08c849bafa1830.svg";
export { ForwardRef as ReactComponent };